import type { FaireProductEntity } from "../../entity_types/product";

export const p_d1cl1gmjt8: FaireProductEntity = {
  token: "p_d1cl1gmjt8",
  type: "product",
  name: "Point Stacking Ring",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/117c3416ffb73687b6ac36a7a293ba666ba302e3b78b2583530aef7d32f80897.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a068845109c830ddb17d0cbf215d50fd0c265401ecab0bda7d96e72c89225f88.jpeg"
  ],
  priceDollars: 5,
  description: "Thin, hammered, brass point ring.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:17.480Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
